export function getEnvName() {
  if (window.runConfig) {
    return window.runConfig.envName
  }
  else {
    return process.env.REACT_APP_ENV
  }
}
